import { sendToNative } from '@/shared/lib/native-bridge/send'
import { NativeBridgeEvents } from '@/shared/lib/native-bridge/types'
import { authPaths } from '@/shared/lib/routing/auth'

import type { Navigate } from './types'

const fallbackNavigate: Navigate = (url: string) => {
  if (typeof window !== 'undefined') window.location.replace(url)
}

/** `_eventSlug` reserved for future tenant-aware no-ticket UX; flat URLs ignore it today. */
export function executeHandleNoTicket(
  inNativeAppWebView: boolean,
  _eventSlug?: string,
  navigate: Navigate = fallbackNavigate
): void {
  if (inNativeAppWebView) {
    sendToNative({ type: NativeBridgeEvents.AUTH_REQUIRED, callbackUrl: '/?error=NoTicket' })
    return
  }

  navigate(authPaths.signIn({ error: 'NoTicket' }))
}
